import React from 'react';
import { useTranslation } from 'react-i18next';
import './About.css';

const About: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="about-page">
      <div className="about-hero">
        <div className="container">
          <h1 className="page-title">{t('about.title')}</h1>
        </div>
      </div>

      <section className="about-section">
        <div className="container">
          <div className="about-content">
            <div className="about-text">
              <h2>{t('about.mission.title')}</h2>
              <p>{t('about.mission.description')}</p>
            </div>
            <div className="about-text">
              <h2>{t('about.vision.title')}</h2>
              <p>{t('about.vision.description')}</p>
            </div>
            <div className="about-text">
              <h2>{t('about.values.title')}</h2>
              <ul className="values-list">
                <li>{t('about.values.value1')}</li>
                <li>{t('about.values.value2')}</li>
                <li>{t('about.values.value3')}</li>
                <li>{t('about.values.value4')}</li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;









